export default __webpack_public_path__ + "static/clothesrail-139ca3a5d3a53d05a2f1b653c0923bd9.png";